// Common CONSTANT file to avoid duplicates within module
const orderConstants = {
  OPEN: 'OPEN',
  MARKET: 'MARKET',
  NO_FREIGHT: 'NO_FREIGHT',
  CONTRACT: 'CONTRACT',

  CONSIGNEE: 'CONSIGNEE',
  VENDOR_DEPOT: 'VENDOR_DEPOT',
  DEPOT: 'DEPOT',

  OUTBOUND: 'OUTBOUND',
  INBOUND: 'INBOUND',
};

export default orderConstants;
